import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import type { CSSProperties, FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { MiniCopyButton } from '../ButtonWithCopy';

interface Props {
  markdown: string;
  style?: CSSProperties;
}

export const MarkdownPreview: FC<Props> = ({ markdown, style }) => {
  return (
    <Container style={style}>
      <CopyButton>
        <MiniCopyButton
          copyValue={markdown}
          title="Copy to clipboard"
          color={RacemapColors.DarkGray}
        />
      </CopyButton>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  padding: 10px;
  background-color: #f7f7f7;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  margin-bottom: 16px;
`;

const CopyButton = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
`;
